import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import {
	Box,
	Button,
	Divider,
	Grid,
	Paper,
	Stack,
	Typography,
} from "@mui/material";

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { makeStyles } from "@mui/styles";
import LoadingButton from "@mui/lab/LoadingButton";

import MasterWeekViewV2 from "../DealMeetings/MasterWeekViewV2";
import palette from "../../theme/palette";
import AppointmentForm from "../Common/AppointmentForm";

import { AppContext } from "../../AppContext";
import BackButton from "../Common/BackButton";
const useStyles = makeStyles((theme) => ({}));


export default function Appointments({ uid, tab }) {
	const [loadingState, setLoadingState] = useState(false);
	const [complete, setComplete] = useState(true);
	const app = useContext(AppContext);
	const manageSubmit = () => {
		setLoadingState(true);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(state),
		};

		fetch("/api/96b1152361724abda95f7f554d142d11", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.href = "/dashboarda";
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};

	const classes = useStyles();

	const [state, setState] = useState({});

	const handleAppointmentAttended = (id) => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/3ed85e8a86b24d72b5fb4cb83a0c8700/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//app.ref.ref.current.handleChangeState({ o: true, m: "Le mail a été renvoyé", s: "success" });
						window.location.reload();
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	const handleAppointmentCanceled = (id) => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/425fd5b9a1cf4861b765b18fdb0bafa5/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//	app.ref.ref.current.handleChangeState({ o: true, m: "Le mail a été renvoyé", s: "success" });
						window.location.reload();
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	useEffect(() => {
		console.log("fire data")
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/d72ff91b83d4442e925632891f73f7b0/", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState({ ...state, ...res.pld });

						setView(tab ? "rdv" : "dispo");
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	useEffect(() => {
		if (state.ambassador_slots_states !== undefined) {
			//	console.log("state.ambassador_slots_states changed", state.ambassador_slots_states)
			//	setComplete(Object.values(state.ambassador_slots_states).filter((v) => { return Math.abs(v) == 2 }).length == 0)
			setComplete(state.changes)
		}
	}, [state]);

	const [view, setView] = useState(undefined);

	const handleChangeView = (event, nextView) => {
		setView(nextView);
	};

	const setLocalUpperState = (obj) => {
		console.log("setLocalUpperState", obj, state.mode)
		if (state.mode == "SETTINGS") {
			state.setState((state) => ({ ...state, ambassador_slots_states: obj, changes: true }));
		} else {
			setState({ ...state, ambassador_slots_states: obj, changes: true });
		}
	};

	console.log("state", state, state.mtgs);
	return (
		<div >
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Paper style="padding: 10px;">
						<Box display="flex" justifyContent="space-between" alignItems="center">
							<Box>
								<BackButton tooltip={"Revenir au tableau de bord"} from={(uid !== undefined ? "/7bac6cb9d6ee4d70b1315393725f3a34/" + uid : "/dashboarda")} />

							</Box>
							<Box>
								<Typography variant="h5" >
									Gestion des disponibilités et des rendez-vous acquéreurs
								</Typography>

							</Box>
							<Box>
								<LoadingButton loading={loadingState} onClick={manageSubmit} variant="contained" color="primary" disabled={!complete}>
									Valider
								</LoadingButton>
							</Box>
						</Box>
					</Paper>
				</Grid>
				<Grid item xs={12} sm={3}>
					<Paper style="padding: 10px; height: 100%; background-color: rgb(240, 240, 240);">

						<Stack justifyContent="center" spacing={2}>
							<ToggleButtonGroup
								orientation="vertical"
								value={view}
								exclusive
								onChange={handleChangeView}
							>
								<ToggleButton value="dispo" aria-label="list" color="primary">
									<Typography >Mes disponibilités</Typography>
								</ToggleButton>
								<ToggleButton value="rdv" aria-label="module" color="primary">
									<Typography >Mes rendez-vous</Typography>
								</ToggleButton>

							</ToggleButtonGroup>
							<Divider />
							<Button variant="contained" onClick={() => app.refPopUp.current.handleChangeState(
								{ opened: true, type: "022" }
							)}>Video d'aide</Button>
						</Stack>
					</Paper>
				</Grid>
				<Grid item xs={12} sm={9}>
					{view === undefined &&
						<Paper style="padding: 20px; background-color: rgba(244, 246, 248, 0.81);">

							<Box display={"flex"} justifyContent={"space-between"} >
								<Box p={0.5} >
									<Stack spacing={1}>
										<Paper style="padding: 4px; visibility: hidden">
											<Typography variant="body1">00:00</Typography>
										</Paper>
										{timeTable.map((hh) => {

											return <Paper style="padding: 4px; " >{hh}</Paper>
											//return 
										})}
									</Stack>
								</Box>
								{[1, 2, 3, 4, 5, 6, 7].map((d) => {

									return <Box p={0.5} style="width: 100%;" >
										<Stack spacing={1}>

											{timeTable.map((hh) => {

												return <Box

													p={0.5}
													style="width: 100%; margin: 0px;">
													<Paper style="text-align: center; padding: 4px; margin: 0px;" >
														<Typography variant="body1" style="text-align: center; padding: 0px; " >
															&nbsp;
														</Typography>
													</Paper></Box>
											})}
										</Stack>
									</Box>
								})}
							</Box>

						</Paper >}
					{view === "dispo" &&

						<MasterWeekViewV2 state={state}
							setUpperState={setLocalUpperState}
						/>
					}
					{view === "rdv" && state.mtgs &&
						state.mtgs.map((m) => {
							return (
								<Grid item xs={6} md={4}>
									<Paper style="margin: 10px; padding: 10px; height: 100%">
										<Stack spacing={1}>
											<Box display="flex" justifyContent="space-between">
												<Box>
													<Typography variant="h5">{m.dt}</Typography>
												</Box>
												<Box>
													<Typography variant="h5">{m.st}</Typography>
												</Box>
											</Box>
											<Typography variant="body1">{m.a}</Typography>
											{m.users.map((att) => (
												<Box display="flex" justifyContent="space-between">
													<Box>
														<Typography variant="body1">{att.nm}</Typography>
													</Box>
													<Box>
														<Typography variant="h5">{att.t}</Typography>
													</Box>
												</Box>
											))}
											{!m.att && !m.cncl && (
												<Paper style={{ padding: "10px", backgroundColor: palette.blueAlert }}>
													<Stack spacing={1}>
														<Typography variant="h5">Le rendez-vous a-t'il eu lieu ?</Typography>
														<Box display="flex" justifyContent="space-between">
															<Box>
																<Button
																	variant="contained"
																	onClick={() => {
																		handleAppointmentAttended(m.u);
																	}}
																>
																	OUI
																</Button>
															</Box>
															<Box>
																<Button
																	variant="contained"
																	onClick={() => {
																		handleAppointmentCanceled(m.u);
																	}}
																>
																	NON
																</Button>
															</Box>
														</Box>
													</Stack>
												</Paper>
											)}
											{m.cncl === true && (
												<Stack spacing={1} justifyContent={"center"}>
													<Paper style={{ padding: "10px", backgroundColor: palette.redAlert }}>

														<Typography variant="h5">Le rendez-vous a été annulé</Typography>


													</Paper>
													{!state.new_meeting && <Button
														variant="contained"
														onClick={() => {
															setState({ ...state, new_meeting: true })
														}}
													>
														Proposer un rendez-vous
													</Button>}
													{state.new_meeting && <AppointmentForm id="aqw" mode="U" />}
												</Stack>
											)}
											{m.att === true && (
												<Paper style={{ padding: "10px", backgroundColor: palette.greenAlert }}>
													<Stack spacing={1}>
														<Typography variant="h5">Le rendez-vous a bien eu lieu</Typography>
													</Stack>
												</Paper>
											)}
										</Stack>
									</Paper>
								</Grid>
							);
						})}
					{view === "rdv" && state.mtgs && state.mtgs.length === 0 &&
						<Paper style="padding: 10px; height: 100%">
							<Typography variant="h5">Vous n'avez aucun rendez-vous actif</Typography>
						</Paper>
					}
				</Grid>

			</Grid>
		</div >
	);


}


const timeTable = new Array(
	"08:00",
	"08:30",
	"09:00",
	"09:30",
	"10:00",
	"10:30",
	"11:00",
	"11:30",
	"12:00",
	"12:30",
	"13:00",
	"13:30",
	"14:00",
	"14:30",
	"15:00",
	"15:30",
	"16:00",
	"16:30",
	"17:00",
	"17:30",
	"18:00",
	"18:30",
	"19:00",
	"19:30",
	"20:00"
);